import * as moment from 'moment-timezone';
import MomentEnum from '../enums/MomentEnum';
import { getHeaderDay, getLocaleDayMobile } from './momentUtils';
var localeMap = {
    'zh': 'zh-cn',
    'en': 'en-gb',
    'no': 'nb',
};
var getLocale = function (locale) {
    try {
        locale = localeMap[locale] || locale;
        require("moment/locale/".concat(locale));
        return locale;
    }
    catch (error) {
        console.log('[getLocale: error] : ', error);
        require("moment/locale/".concat(localeMap.en));
        return localeMap.en;
    }
};
export function getCurrentWeekMobile(firstDay, dateOnFocuse, locale) {
    locale = getLocale(locale) || locale;
    var days = [];
    moment.updateLocale('en', {
        // @ts-expect-error
        week: {
            dow: firstDay,
        },
    });
    var dayIndex = moment
        .utc(dateOnFocuse)
        .locale(MomentEnum.en)
        .startOf(MomentEnum.week)
        .add(firstDay, MomentEnum.days);
    for (var i = 0; i < 7; i++) {
        days.push({
            date: dayIndex.format(MomentEnum.fullDayOfMonth),
            day: getLocaleDayMobile(locale, dayIndex, MomentEnum.fullWeekDayName),
            isToday: dayIndex.format(MomentEnum.yearMonthDay) ===
                moment().format(MomentEnum.yearMonthDay),
            eventDate: dayIndex.format(MomentEnum.yearMonthDay),
            momentDate: moment(dayIndex.format(MomentEnum.yearMonthDay)).toDate(),
        });
        dayIndex.add(1, MomentEnum.days);
    }
    return days;
}
export function getCurrentWeek(firstDay, dateOnFocuse, locale) {
    locale = getLocale(locale) || locale;
    moment.updateLocale('en', {
        // @ts-expect-error
        week: {
            dow: firstDay,
        },
    });
    var currentDate = moment.utc(dateOnFocuse);
    var weekStart = currentDate.clone().startOf(MomentEnum.week);
    var days = [];
    for (var i = 0; i < 7; i++) {
        days.push({
            date: getHeaderDay(weekStart, locale, i, MomentEnum.fullDayOfMonth),
            day: getHeaderDay(weekStart, locale, i, MomentEnum.fullWeekDayName),
            isToday: moment(weekStart)
                .add(i, MomentEnum.daysString)
                .format(MomentEnum.yearMonthDay) ===
                moment().format(MomentEnum.yearMonthDay),
            momentDate: moment(moment(weekStart)
                .add(i, MomentEnum.daysString)
                .format(MomentEnum.yearMonthDay)).toDate(),
            weekDay: getHeaderDay(weekStart, locale, i, MomentEnum.shortWeekDayName),
        });
    }
    return days;
}
//# sourceMappingURL=momentTimezoneUtils.js.map